import {
  ADD_LOAN_TO_CART_API_REQUEST,
  ADD_LOAN_TO_CART_API_ERROR,
  ADD_LOAN_TO_CART_API_SUCCESS,
  ADD_LOAN_TO_CART_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function addLoanToCartApiRequest() {
  return {
    type: ADD_LOAN_TO_CART_API_REQUEST,
    payload: true,
  };
}

function addLoanToCartApiSuccess(localCart, cart, params) {
  return {
    type: ADD_LOAN_TO_CART_API_SUCCESS,
    payload: cart,
    local: localCart,
    params,
  };
}

function addLoanToCartApiError(err) {
  return {
    type: ADD_LOAN_TO_CART_API_ERROR,
    payload: err,
  };
}

export function addLoanToCartAction(localCartItem, params) {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(addLoanToCartApiRequest());
    return cartApi
      .addLoanToCart(state, params)
      .then(data => {
        dispatch(addLoanToCartApiSuccess(localCartItem, data, params));
        return data;
      })
      .catch(error => {
        dispatch(addLoanToCartApiError(error));
        throw error;
      });
  };
}

export default { addLoanToCartAction };
